import UILoader from '@components/ui-loader';
import './table-loader.scss';

function TableLoader() {
  return <UILoader blocking className="table-overlay" />;
}

export default TableLoader;
